import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { SettingsService } from './settings-page/settings-service/settings.service';

export const tradeStudyToolsGuard: CanMatchFn = () => {
  const settingsService = inject(SettingsService);
  return settingsService.isTradeStudyToolFeaturesEnabled$();
};
